// ============================================================
// ColonieSettingsModal.js
// Portal credentials (username/password for coloniedesreves.com)
// ============================================================

import React, { useState, useEffect } from 'react';
import { X, Settings } from 'lucide-react';

const ColonieSettingsModal = ({ onClose, apiCall, showError, showSuccess }) => {
  const [form, setForm]   = useState({ portalUrl: 'https://cms.coloniedesreves.com', username: '', password: '' });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    apiCall('/colonie/portal-config')
      .then(d => { if (d) setForm(f => ({ ...f, portalUrl: d.PortalURL, username: d.Username })); })
      .catch(() => {});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await apiCall('/colonie/portal-config', { method: 'POST', body: JSON.stringify(form) });
      showSuccess('Portal credentials saved');
      onClose();
    } catch (err) { showError(err.message); }
    finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm">
        <div className="flex items-center justify-between p-5 border-b">
          <h2 className="font-bold text-gray-800 flex items-center gap-2">
            <Settings size={17}/>Portal Settings
          </h2>
          <button onClick={onClose}><X size={17} className="text-gray-400"/></button>
        </div>

        <div className="p-5 space-y-4">
          <p className="text-xs text-gray-500">
            Used to sync registrations and auto-confirm payments on coloniedesreves.com.
          </p>
          {[
            { k: 'portalUrl', l: 'Portal URL',  t: 'text' },
            { k: 'username',  l: 'Username',    t: 'text' },
            { k: 'password',  l: 'Password',    t: 'password' },
          ].map(f => (
            <div key={f.k}>
              <label className="block text-sm font-semibold text-gray-700 mb-1">{f.l}</label>
              <input type={f.t} value={form[f.k]} onChange={e => setForm({ ...form, [f.k]: e.target.value })}
                className="w-full border border-gray-300 rounded-xl px-4 py-2.5 text-sm focus:ring-2 focus:ring-blue-400"/>
            </div>
          ))}
        </div>

        <div className="flex gap-3 p-5 pt-0">
          <button onClick={onClose} className="flex-1 py-3 border border-gray-300 rounded-xl font-semibold text-gray-700">Cancel</button>
          <button onClick={save} disabled={saving}
            className="flex-1 py-3 bg-blue-600 text-white rounded-xl font-semibold disabled:opacity-50">
            {saving ? 'Saving…' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ColonieSettingsModal;
